(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusReviewInitiativeController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'initAssessmentsByAssessor', 'assessmentByInitiative', 'fiscalYearQuarterKeys'];

    function Controller($scope, $state, topBarService, initAssessmentsByAssessor, assessmentByInitiative, fiscalYearQuarterKeys) {

        if (redirectToDeliverables(assessmentByInitiative)) {
            $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverables', { replace: true });
        }

        topBarService.setTitleAndIcon('Business Planning', 'fa fa-compass', 'Review Status Update', 'fa fa-umbrella');

        $scope.ctrlCtxt = {};

        $scope.initAssessmentsByAssessor = initAssessmentsByAssessor;
        $scope.fiscalYearQuarterKeys     = fiscalYearQuarterKeys;
        $scope.planInitiative = assessmentByInitiative.PlanInitiative;
        $scope.planInitiativeAssessment = assessmentByInitiative.PlanInitiativeAssessment;
        $scope.initiativesList = assessmentByInitiative.InitiativesList;

        function redirectToDeliverables(assessmentByInitiative) {
            if (!$state.is('initiativeUpdateStatusReview.initiatives.review.byInitiative.assessment')) return false;
            if (_.isUndefined(assessmentByInitiative.PlanInitiativeAssessment)) return false;

            return !assessmentByInitiative.PlanInitiativeAssessment.AreAllDeliverablesReviewed;
        }
    }
})();
